<template>
  <v-btn
    class="primary button-plain custom-button"
    rounded="pill"
    :size="buttonSize"
    elevation="1"
    :height="buttonHeight"
    :width="buttonWidth"
  >
    <b>{{ buttonName }}</b>
  </v-btn>
</template>

<script>
export default {
  name: "ButtonPlain",
  props: {
    buttonName: {
      type: String,
      default: "",
    },
    buttonSize: {
      type: String,
      default: "large",
    },
    buttonHeight: {
      type: String,
      default: "50",
    },
    buttonWidth: {
      type: String,
      default: "270",
    },
    iconPlacement: {
      type: String,
      default: "",
    },
    buttonIcon: {
      type: String,
      default: "",
    },
    process: {
      type: Function,
      default: null,
    }, // Dynamic method
  },
};
</script>

<style>
.button-plain {
  width: 300px;
}

@media screen and (max-width: 600px) {
  .button-plain {
    width: 100%;
  }
}
</style>
